export default "__VITE_ASSET__DYP9WV5Z__"